/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ct_Tagline_DefaultInputs */

const en_ct_tagline_default = /** @type {(inputs: Ct_Tagline_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect or Write Me`)
};

const ar_ct_tagline_default = /** @type {(inputs: Ct_Tagline_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تواصل أو راسلني`)
};

const bn_ct_tagline_default = /** @type {(inputs: Ct_Tagline_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`যোগাযোগ করুন বা মেসেজ দিন`)
};

const de_ct_tagline_default = /** @type {(inputs: Ct_Tagline_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt aufnehmen oder schreiben`)
};

const es_ct_tagline_default = /** @type {(inputs: Ct_Tagline_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conecta o escríbeme`)
};

const fr_ct_tagline_default = /** @type {(inputs: Ct_Tagline_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contactez-moi ou écrivez-moi`)
};

const pt_ct_tagline_default = /** @type {(inputs: Ct_Tagline_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entre em contato ou escreva para mim`)
};

const zh_ct_tagline_default = /** @type {(inputs: Ct_Tagline_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`联系或写信给我`)
};

const tr_ct_tagline_default = /** @type {(inputs: Ct_Tagline_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bağlan veya Bana Yaz`)
};

const ru_ct_tagline_default = /** @type {(inputs: Ct_Tagline_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подключитесь или напишите мне`)
};

const pl_ct_tagline_default = /** @type {(inputs: Ct_Tagline_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Połącz się lub napisz do mnie`)
};

/**
* | output |
* | --- |
* | "Connect or Write Me" |
*
* @param {Ct_Tagline_DefaultInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const ct_tagline_default = /** @type {((inputs?: Ct_Tagline_DefaultInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ct_Tagline_DefaultInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_ct_tagline_default(inputs)
	if (locale === "bn") return bn_ct_tagline_default(inputs)
	if (locale === "de") return de_ct_tagline_default(inputs)
	if (locale === "es") return es_ct_tagline_default(inputs)
	if (locale === "fr") return fr_ct_tagline_default(inputs)
	if (locale === "pt") return pt_ct_tagline_default(inputs)
	if (locale === "zh") return zh_ct_tagline_default(inputs)
	if (locale === "tr") return tr_ct_tagline_default(inputs)
	if (locale === "ru") return ru_ct_tagline_default(inputs)
	if (locale === "pl") return pl_ct_tagline_default(inputs)
	return en_ct_tagline_default(inputs)
});